// import { ZnAxios } from '@/tools/rpcTools'

import { ZnAxios } from '@/tools/rpcTools';

export function testApi() {
    return ZnAxios({
      method: 'tuner.channel.get',
    })
  }
